<template>
  <!-- 活动管理-新年活动配置 -->
  <div class="test-box">
    <!-- header头部 -->

    <header>
      <el-form :model="dataForm" ref="dataForm" label-width="120px">
        <el-form-item label="PC图片：">
          <ImgUpload v-model="dataForm.image"></ImgUpload>
        </el-form-item>
        <el-form-item label="移动端图片：">
          <ImgUpload v-model="dataForm.image_m"></ImgUpload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box"></div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import http, {
  server,
  api,
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '@/http'
import ImgUpload from '@/components/common/ImgUpload.vue'

export default {
  components: {
    ImgUpload
  },
  data() {
    return {
      loading: false, //加载动画
      dataForm: {
        image: '',
        image_m: '',
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      getApiData('activity_img').then(res => {
        if (res) {
          this.dataForm = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    //保存图片
    submit() {
      if (!this.dataForm.image || !this.dataForm.image_m) {
        this.$message.error("请上传全部图片后保存")
        return
      }

      let params = this.dataForm
      patchApiData('activity_img', params).then(res => {
        this.$message.success("保存成功！")
      }).finally(() => {
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}

</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {
  }

  .body-box {
    // width: 800px;
  }
}
</style>
